import React from 'react';
import Odj from './Manager/Odj';
import Action from './Manager/Action';
import Speakers from './Manager/Speakers';
import Preview from './Manager/Preview';
import Custom from './Manager/Custom';
import BroadcastInfo from './Manager/BroadcastInfo';
import Grid from '@material-ui/core/Grid';

export default class Manager extends React.Component {

  state = {
    showCustom: false,
    customType: '',
    loading: true
  }

  key = '';
  tmpLi = []

  goSpeaker() {
    var list = document.getElementById('speaker_list');
  

    console.log(this.key.toUpperCase());
    let els = document.querySelectorAll("[class*=name-" + this.key.toUpperCase() + "]");

    console.log(els);

    for (var i in this.tmpLi) {
      this.tmpLi[i].style.backgroundColor = 'inherit';
    }

    this.tmpLi = [];
    
    let color = '#ffff99'
    if(els.length < 2)
      color = 'green'

    els.forEach((li) => {
      li.style.backgroundColor = color;
      this.tmpLi.push(li)
    });

    if(els[0]) {
      console.log(list.scrollTop, els[0].offsetTop)
      list.scrollTop = (els[0].offsetTop - 50);
    }



  }
  
  clearSpeaker() {
    this.key = '';
    for (var i in this.tmpLi) {
      this.tmpLi[i].style.backgroundColor = 'inherit';
    }

    this.tmpLi = [];
  }

  async componentDidMount() {

    if (window.isVod) {
      this.setState({
        loading: false
      })
    }
    else {

      window.addEventListener("keydown", (event) => {
        let str = "KeyboardEvent: key='" + event.key + "' | code='" +
            event.code + "'";
        
        if(this.timeout) {
          clearTimeout(this.timeout);
        }
        
        if(event.key.toUpperCase() == 'ENTER' && this.tmpLi.length == 1) {
          let id = this.tmpLi[0].id.split('-').pop().trim();
          
          window.sdk.emit('setLiveCurrentSpeakerEvent_' + id);
          this.clearSpeaker();
          return;
        }
        
        if(event.key.toUpperCase() == 'BACKSPACE') {
          this.clearSpeaker();
          return;
        }
  
        //console.log(str);
        
        this.key += event.key;

        this.goSpeaker()

        this.timeout = setTimeout(() => {
          this.key = '';
          for (var i in this.tmpLi) {
            this.tmpLi[i].style.backgroundColor = 'inherit';
          }

          this.tmpLi = [];
        }, 3000);

      }, true);

      await window.sdk.live.loadInfo(window.programId);
      await window.sdk.live.loadCuepoints();
      this.setState({
        loading: false
      })
    }

    window.sdk.on('showCustom', (data) => {
      this.setState({
        showCustom: true,
        customType: data.type
      })
    })

    window.sdk.on('hideCustom', (data) => {
      this.setState({
        showCustom: false
      })
    })

    window.sdk.on('reloadIframe', (data) => {
      var iframe = document.getElementById('vod_iframe');
      iframe.src = iframe.src;
    })

  }

  render() {
    if (this.state.loading)
      return null;



    return (
      <div id="manager">
        { this.state.showCustom &&
          <Custom type={this.state.customType} />
        }
        { !window.isVod &&
          <Grid direction="row">
            <Grid item xs={12}>
              <Action />
            </Grid>
            <Grid className="floatMe" item xs={4}>
              <BroadcastInfo />
              <Preview />
            </Grid>
            <Grid className="floatMe" item xs={4}>
              <Odj />
            </Grid>
            <Grid className="floatMe" item xs={4}>
              <Speakers />
            </Grid>
          </Grid>
        }
        { window.isVod &&
          <Grid  container direction="row">
            <Grid item xs={12}>
              <Action />
            </Grid>
            <Grid item xs={12}>
              <iframe id="vod_iframe" src={ '/vod/' + window.programId + '?v4=1' }></iframe>
            </Grid>
          </Grid>
        }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/Manager.js